export default {
  // / <summary>
  // / Cơ cấu
  // / </summary>
  Invest: 1,
  Regular: 2,
};
